import { render, staticRenderFns } from "./ANxALxAcademBasicPage.vue?vue&type=template&id=1649c304"
import script from "./ANxALxAcademBasicPage.vue?vue&type=script&lang=js"
export * from "./ANxALxAcademBasicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports